// import { rejectToAgent } from '@/API';
import { saveOrderContractInfo, rejectToAgent, checkLinePrice } from '@/API';
import { buildContractComplianceRequest, checkExportCompliance, isDomesticContract } from '@/libs/exportCompliance';
export default {
  methods: {
    async submit (val, cal) {
      const result = await this.cloudPrice();
      if (!result) {
        this.$refs.actions.loading = false;
        return;
      }
      // this.cloudPrice();this.cloudPrice()
      if (Number(this.form.assignAll * 100 / this.form.actualSettlementAmount).toFixed(2) < 5) {
        this.$confirm('已分配比例小于5%, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.submitAction(val, cal);
        }).catch((e) => {
          console.error(e);
          this.$notify({
            type: 'info',
            message: '取消发布合同'
          });
          this.$refs.actions.loading = false;
        });
      } else {
        this.submitAction(val, cal);
      }
    },
    // 设置 云产品价格拦截
    async cloudPrice () {
      let params = [];
      let product = await this.$refs.product.productList;
      // 筛选 数组到parmas
      product.map((item) => {
        if (item.highlight === 1) {
          params.push({ productCode: item.productCode, productName: item.productName, productPrice: item.beforeSplitProductPriceSigle });
        };
      });
      let result = await checkLinePrice(params);
      let json = result.data;
      if (json.status === '200') {
        if (json.data.length === 0) {
          return true;
        } else {
          let nameAllProduct = '';
          json.data.map((item) => {
            nameAllProduct += item.productName + ',';
          });
          // this.$message.error();
          this.$notify.error(nameAllProduct + '价格低于底线价，请驳回');
          return false;
        }
      } else {
        return false;
      }
    },
    async submitAction (val, cal) {
      let baseR = true;
      let Product = {};
      let error = '';
      if (!val) {
        baseR = await this.$refs.baseInfo.validate();
      } else {
        baseR = await this.$refs.baseInfo.validatedrafts();
      }
      if (!baseR) {
        this.loading = false;
        cal(false);
        return;
      }
      if (val) {
        Product = await this.$refs.product.validateDraft();
      } else {
        Product = await this.$refs.product.validate();
      }
      let useRebateVO = this.$refs.freightInfo.validate();
      if (!useRebateVO) {
        cal(false);
        return;
      }
      if (baseR && Product && useRebateVO) {
        val ? baseR.contractInfo.isDraft = true : baseR.contractInfo.isDraft = false;
        baseR.contractDetail.actualSettlementAmount = Product.actualSettlementAmount;
        baseR.contractDetail.orderSales = Product.orderSales;
        // baseR.contractInfo.contractSum = Product.netSales;
        this.loading = true;
        let newProductList = [];
        Product.productList.forEach((item) => {
          item.authorizationEmail = this.form.authorizationEmail;
          newProductList.push(item);
        });
        newProductList.forEach((item) => {
          if (!item.materialUnit) {
            error = `${item.materialNumberId}料号单位为空，请试试重新选择！`;
          }
        });

        if (error) {
          this.$notify.error(error);
          this.$refs.actions.loading = false;
          return;
        }
        if (!val && isDomesticContract({ ...this.form, civilInternational: baseR.civilInternational })) {
          const decision = await checkExportCompliance(this,
            buildContractComplianceRequest(this.form, baseR, newProductList, this.$refs.product.address));
          if (!decision.allowBusiness) {
            this.loading = false;
            this.$refs.actions.loading = false;
            cal(false);
            return;
          }
        }
        saveOrderContractInfo({ ...baseR, contractProductInfos: newProductList, useRebateVO }).then((res) => {
          let json = res.data;
          this.loading = false;
          cal(false);
          if (json.status === '200') {
            if (val) {
              this.$router.replace({ name: 'orderPersionDrafts' });
            } else {
              this.$router.replace({ name: 'orderPersionContractList' });
            }
          }
        }).catch(() => {
          this.loading = false;
          cal(false);
        });
      } else {
        this.loading = false;
        cal(false);
      }
    },
    Reject (cal) {
      rejectToAgent(this.form.id).then((res) => {
        cal();
        let json = res.data;
        if (json.status === '200') {
          this.$router.replace({
            name: 'orderPersionContractList'
          });
        }
      }).catch(() => {
        cal();
      });
    },
    suggestionInfo () {
      this.$refs.rejected.showRejectDialog();
    }
  }
};
